import AttachmentsUploadQueueItemComponent from './queue-item.component'

const AttachmentsUploadQueueItemModule = angular.module('cdbl.attachments.queue-item', [

])
  .component('cdblAttachmentsUploadQueueItem', AttachmentsUploadQueueItemComponent)
  .name

export default AttachmentsUploadQueueItemModule
